import 'react-phone-number-input/style.css';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
// import { useState } from 'react';

export function PhoneNumInput({ value, onChange, name }) {
  // `value` will be the parsed phone number in E.164 format.
  // Example: "+12133734253".
  // const [value, setValue] = useState();
  return (
    <PhoneInput
      placeholder="+998 ( _ _ ) _ _ _ - _ _ - _ _"
      value={value}
      minLength="17"
      maxLength="17"
      required
      error={
        value
          ? isValidPhoneNumber(value)
            ? undefined
            : 'Invalid phone number'
          : 'Phone number required'
      }
      onChange={e =>
        onChange({
          target: {
            value: e,
            name: 'phone',
          },
        })
      }
      name={name}
    />
  );
}
